import React, { Component } from 'react';
import logoPosible from '../../../images/logo/PosibleLogo.png';
// import logoWRX from '../../../images/logo/WRXLogo.svg';
// import logoSMAPP from '../../../images/logo/SMLogo.png';
import brewfactorLogo from "../../../images/logo/brewfactorLogo.png";
import logoOption1 from "../../../whitelabel_asset/logo_option1.png"
import logoOption2 from "../../../whitelabel_asset/logo_option2.png"
import logoOption3 from "../../../whitelabel_asset/logo_option3.png"
import logoOption4 from "../../../whitelabel_asset/logo_option4.png"

class Logo extends Component {

    renderLogo() {
        // if(this.props.config  && this.props.config.WhiteLabel && this.props.config.WhiteLabel.Code==="POSIBLE"){
        //     return <img  style={{ height: this.props.height ?  this.props.height : "122px" }} src={logoPosible}/>
        // }
        // if(this.props.config  && this.props.config.WhiteLabel && this.props.config.WhiteLabel.Code==="WRX"){
        //     return <img  style={{ height: this.props.height ?  this.props.height : "122px" }} src={logoWRX}/>            
        // }
        // if(this.props.config  && this.props.config.WhiteLabel && this.props.config.WhiteLabel.Code==="SMAPP"){
        //     return <img style={{ height: this.props.height ?  this.props.height : "122px" }} src={logoSMAPP}/>            
        // }

        //   if(this.props.config  && this.props.config.WhiteLabel && this.props.config.WhiteLabel.Code==="BREWFACTOR"){
        //     return <img style={{ height: this.props.height ?  this.props.height : "122px" }} src={brewfactorLogo}/>            
        // }
        //  if(this.props.config  && this.props.config.WhiteLabel && this.props.config.WhiteLabel.Code==="POSIBLE"){
        //     return <img  style={{ height: this.props.height ?  this.props.height : "122px" }} src={logoPosible}/>
        // }
        if (this.props.logoOption) {
            const logos = {
                1: logoOption1,
                2: logoOption2,
                3: logoOption3,
                4: logoOption4,
            };

            return (
                <img
                    style={{ height: this.props.height ? this.props.height : "122px" }}
                    src={logos[this.props.logoOption]}
                    onClick={this.props.onClick}
                    alt="logo"
                />
            );
        }
        return <div></div>
    }

    render() {
        return <React.Fragment>
            {this.renderLogo()}
        </React.Fragment>
    }
}

export default Logo;
